export default "__VITE_ASSET__DDuZIyCd__"